module.exports = __webpack_public_path__ + "img/CLS-P-410.38b12ddf.svg";